// Debug utility for React application
// Этот файл экспортирует функции отладки, которые работают только в debug режиме

// Проверяем включен ли режим отладки
export const isDebugMode = () => {
  return (
    import.meta.env.REACT_APP_DEBUG === "true" ||
    import.meta.env.NODE_ENV === "development"
  );
};

// Получение правильного API endpoint
export const getApiEndpoint = (endpoint) => {
  // В production НИКОГДА не используем localhost
  const isProduction = import.meta.env.MODE === 'production' || import.meta.env.PROD;
  
  if (isProduction) {
    // В production всегда возвращаем endpoint как есть
    return endpoint;
  }
  
  // Только в development можем использовать localhost
  if (isDebugMode()) {
    const localBase = "http://localhost:3131";

    // Если это уже полный URL, возвращаем как есть
    if (endpoint.startsWith("http")) {
      return endpoint;
    }

    // Добавляем локальный базовый URL
    return `${localBase}${
      endpoint.startsWith("/") ? endpoint : "/" + endpoint
    }`;
  }

  return endpoint;
};

// Функция для логирования отладочной информации
export const debugLog = (component, message, ...args) => {
  if (isDebugMode()) {
    const timestamp = new Date().toISOString();
    console.log(`[DEBUG] ${timestamp} [${component}] ${message}`, ...args);
  }
};

// Функция для логирования информационных сообщений
export const debugInfo = (component, message, ...args) => {
  if (isDebugMode()) {
    const timestamp = new Date().toISOString();
    console.info(`[INFO] ${timestamp} [${component}] ${message}`, ...args);
  }
};

// Функция для логирования предупреждений
export const debugWarn = (component, message, ...args) => {
  if (isDebugMode()) {
    const timestamp = new Date().toISOString();
    console.warn(`[WARN] ${timestamp} [${component}] ${message}`, ...args);
  }
};

// Функция для логирования ошибок (работает всегда)
export const debugError = (component, message, ...args) => {
  const timestamp = new Date().toISOString();
  console.error(`[ERROR] ${timestamp} [${component}] ${message}`, ...args);
};

// Функция для измерения времени выполнения
export const debugTime = (label) => {
  if (isDebugMode()) {
    console.time(`[DEBUG TIMER] ${label}`);
  }
};

export const debugTimeEnd = (label) => {
  if (isDebugMode()) {
    console.timeEnd(`[DEBUG TIMER] ${label}`);
  }
};

// Функция для логирования объектов
export const debugObject = (component, label, obj) => {
  if (isDebugMode()) {
    const timestamp = new Date().toISOString();
    console.group(`[DEBUG] ${timestamp} [${component}] ${label}`);
    console.table(obj);
    console.groupEnd();
  }
};

// Функция для логирования API вызовов
export const debugApiCall = (component, method, url, data = null) => {
  if (isDebugMode()) {
    const timestamp = new Date().toISOString();
    console.group(`[API] ${timestamp} [${component}] ${method} ${url}`);
    if (data) {
      console.log("Request data:", data);
    }
    console.groupEnd();
  }
};

// Функция для логирования ответов API
export const debugApiResponse = (component, url, response, error = null) => {
  if (isDebugMode()) {
    const timestamp = new Date().toISOString();
    const status = error ? "ERROR" : "SUCCESS";
    console.group(
      `[API RESPONSE] ${timestamp} [${component}] ${status} ${url}`
    );
    if (error) {
      console.error("Error:", error);
    } else {
      console.log("Response:", response);
    }
    console.groupEnd();
  }
};

// Функция для отслеживания производительности компонентов
export const debugComponentRender = (componentName, props = {}) => {
  if (isDebugMode()) {
    const timestamp = new Date().toISOString();
    console.log(
      `[RENDER] ${timestamp} [${componentName}] Component rendered with props:`,
      props
    );
  }
};

// Функция для отслеживания изменений состояния
export const debugStateChange = (component, stateName, oldValue, newValue) => {
  if (isDebugMode()) {
    const timestamp = new Date().toISOString();
    console.group(`[STATE] ${timestamp} [${component}] ${stateName} changed`);
    console.log("Old value:", oldValue);
    console.log("New value:", newValue);
    console.groupEnd();
  }
};

// Проверка среды выполнения
export const getEnvironmentInfo = () => {
  return {
    nodeEnv: import.meta.env.NODE_ENV,
    debugMode: isDebugMode(),
    userAgent: navigator.userAgent,
    url: window.location.href,
    timestamp: new Date().toISOString(),
  };
};

// Логирование информации о среде
export const logEnvironmentInfo = () => {
  if (isDebugMode()) {
    console.group("[ENVIRONMENT INFO]");
    console.table(getEnvironmentInfo());
    console.groupEnd();
  }
};
